import { render } from "./TaskNewComment.vue?vue&type=template&id=23e26e97&scoped=true"
import script from "./TaskNewComment.vue?vue&type=script&lang=js"
export * from "./TaskNewComment.vue?vue&type=script&lang=js"

import "./TaskNewComment.vue?vue&type=style&index=0&id=23e26e97&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23e26e97"]])

export default __exports__